import React from "react";
import SwitchTokensIcon from "../../../img/butter_svgs/SwitchTokens.svg?react";
import styled from "@emotion/styled";
import { FlexContainer } from "containers/FlexContainer";

export interface SwitchTokensProps {
  isVisible: boolean;
  onClick: () => void;
  isWrap?: boolean;
}

export const SwitchTokensButton: React.FC<SwitchTokensProps> = props => {
  if (!props.isVisible) {
    return null;
  }

  return (
    <SwitchTokensContaner>
      <LeftLine />
      <SwitchButton onClick={() => props.onClick()}>
        <SwitchTokensIcon />
      </SwitchButton>
      <RightLine />
    </SwitchTokensContaner>
  );
};

const SwitchTokensContaner = styled(FlexContainer)`
  display: flex;
  padding: 12px 0;
  justify-content: center;
  align-items: center;
  align-self: stretch;
`;
export const LeftLine = styled.div`
  border-bottom: 2px solid ${props => props.theme.button.tertiary.surface.default};
  width: 100%;
  height: 2px;
`;
export const RightLine = styled.div`
  width: 100%;
  height: 2px;
  border-bottom: 2px solid ${props => props.theme.button.tertiary.surface.default};
`;

export const SwitchButton = styled.div`
  background: ${props => props.theme.button.tertiary.surface.default};
  border-radius: 14px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  fill: #e9ba04;
  cursor: pointer;
  &:hover {
    background: ${props => props.theme.button.tertiary.surface.hover};
    transform: rotate(180deg);
    transition: transform 0.5s ease;
  }
`;
